import {
  FIND_APPEAL,
  FIND_APPEAL_SUCCESS,
  FIND_APPEAL_ERROR,
  RESET_APPEAL,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  loading: false,
  error: false
};

const appealFindRequest = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FIND_APPEAL:
      return {
        ...state,
        loading: true,
        error: false
      };
    case FIND_APPEAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: {
          ...payload
        }
      };
    case FIND_APPEAL_ERROR:
      return {
        loading: false,
        error: true,
        data: null
      };
    case RESET_APPEAL:
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default appealFindRequest;
